export default __webpack_public_path__ + "static/hero-recipes-bg-desktop2-0ac926fe32898de309b08a9be6c64357.jpg";